import PropTypes from 'prop-types';
import React from 'react';
import {
  PaginationInformation,
  PageSelection,
  PageSizeSelector,
} from '@unite-us/app-components';

const noop = () => {};

export function Pagination({
  pageNumber,
  pageSize,
  setPageNumber,
  setPageSize,
  totalItemCount,
  totalPageCount,
}) {
  return (
    <nav
      aria-label="Interactions pagination"
      className="mt-9 flex items-end justify-between gap-4 text-14px"
    >
      <PaginationInformation
        className="font-regular-font text-text-blue sm:hidden lg:block"
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalItemCount={totalItemCount}
      />
      {totalItemCount ? (
        <>
          <PageSelection
            className="max-w-3xl flex-grow"
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalPageCount={totalPageCount}
            scrollPaginationElement={noop}
          />
          <PageSizeSelector
            pageSize={pageSize}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
          />
        </>
      ) : null}
    </nav>
  );
}

Pagination.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  setPageSize: PropTypes.func.isRequired,
  totalItemCount: PropTypes.number.isRequired,
  totalPageCount: PropTypes.number.isRequired,
};
